import React, { useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";

import PageHeader from "./components/PageHeader";
import TableList from "./components/TableList";
import TableForm from "./components/TableForm";
import { useTables } from "./components/useTables";
import { useUser } from "../UserContext";

import "react-toastify/dist/ReactToastify.css";
import "../../css/DBTablePage.css";


function CreateTablePage() {

  const { role } = useUser(); // Ottieni il ruolo dell’utente loggato
  
  const [selectedTable, setSelectedTable] = useState("");
  const { tables, fetchTables } = useTables(process.env.REACT_APP_API_URL);

  const API_URL = process.env.REACT_APP_API_URL;
  const isButtonEnabled = selectedTable.trim().length > 0 && /^[a-zA-Z0-9_]+$/.test(selectedTable);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const tableName = selectedTable.trim();
    if (!isButtonEnabled) return toast.warning("Nome non valido.");

    const existing = tables.map(t => t.name.toLowerCase());
    if (existing.includes(tableName.toLowerCase()))
      return toast.warning("Tabella già esistente.");

    const formData = new URLSearchParams();
    formData.append("newTableName", tableName);

    try {
      const res = await fetch(`${API_URL}/createTableDB`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });

      if (!res.ok) throw new Error("Errore durante la creazione della tabella");

      toast.success(`Tabella "${tableName}" creata con successo`);
      setSelectedTable("");
      fetchTables();
    } catch (err) {
      toast.error(err.message);
    }
  };

  // Se utente non loggato, mostra solo un messaggio
  if (!role) {
    return (
      <Container className="mt-5 text-center">
        <h5>Effettua il login per inserire nuovi dati.</h5>
      </Container>
    );
  }
  


  return (
    <Container className="mt-5">
      <ToastContainer position="top-right" autoClose={3000} />
      <PageHeader title="Creazione nuova tabella" />

      <Row className="mt-5 mb-5 justify-content-center align-items-stretch g-4">
        <Col xs={12} md={6}>
          <TableList tables={tables} />
        </Col>

        <Col xs={12} md={6}>
          <TableForm
            title="🆕 Crea una nuova tabella"
            onSubmit={handleSubmit}
            buttonLabel="CREA TABELLA"
            buttonDisabled={!isButtonEnabled}
          >
            <Form.Group controlId="tableName">
              <Form.Label><strong>Nome nuova tabella</strong></Form.Label>
              <Form.Control
                type="text"
                placeholder="Inserisci nome nuova tabella"
                value={selectedTable}
                onChange={(e) => setSelectedTable(e.target.value)}
              />
            </Form.Group>
          </TableForm>
        </Col>
      </Row>
    </Container>
  );
}

export default CreateTablePage;
